module.exports = __webpack_public_path__ + "static/media/the-air-filter-company.23b515f9.svg";